import React, { Component } from 'react';
import { Table, Form, FormGroup, Input } from 'reactstrap';
import { Doughnut } from 'react-chartjs-2';
import districtPerformance from './data/districtPerformance.json'
import './SidebarDistrictChart.css';
import _ from 'lodash';


const round = (number, places=1) => {
   const m = Math.pow(10, places);
   return Math.floor(number * m) / m;
}

const categoryListTemp = districtPerformance.map(({Strucutres, GFA, EUI, Total, ...keepAttrs}) => keepAttrs);
const categoryList = [...new Set(categoryListTemp.map(({Category}) => Category))];


class SidebarDistrictChart extends Component {
	  constructor (props) {
    super(props);

    this.state={ 
			categorySelect: categoryList,
			category: 'All Building Categories',
			totalEnergy: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].Total,
			totalGFA: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].GFA,
			totalGhg: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].TotalGHG,
			totalStructures: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].Structures,
			categoryEnergy: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].Total,
			categoryEui: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].EUI,
			categoryGFA: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].GFA,
			categoryStructures: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].Structures,
			categoryElectricity: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].Electricity,
			categoryNaturalGas: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].NaturalGas,
			categoryDistrictHeating: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].DistrictHeating,
			categoryDistrictCooling: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].DeepLake,
			categoryWater: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].Water,
			categoryGhg: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].TotalGHG,
			categoryElectricityGHG: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].ElectricityGHG,
			categoryNaturalGasGHG: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].NaturalGasGHG,
			categoryDistrictHeatingGHG: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].DistrictHeatingGHG,
			categoryDistrictCoolingGHG: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].DeepLakeGHG,
			categoryWaterGHG: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].WaterGHG,
			dropdownOpen: false,
		};
	}
		

	componentDidMount() {
			window.addEventListener("resize", this.resize.bind(this));
			this.resize();
	}

	resize() {
		if(window.innerWidth >= 768 && window.innerWidth <= 1080) {
			this.setState({legendPos: 'bottom'});
		} else {
			this.setState({legendPos: 'right'});
		}
	}

  toggle = () => {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }
	
	handleCategorySelect = (e) => {
		if(e.target.value === '') {
			this.setState({
				category: 'All Building Categories',
				categoryEnergy: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].Total,
				categoryEui: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].EUI,
				categoryGFA: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].GFA,
				categoryStructures: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].Structures,
				categoryElectricity: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].Electricity,
				categoryNaturalGas: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].NaturalGas,
				categoryDistrictHeating: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].DistrictHeating,
				categoryDistrictCooling: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].DeepLake,
				categoryWater: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].Water,
				categoryGhg: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].TotalGHG,
				categoryElectricityGHG: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].ElectricityGHG,
				categoryNaturalGasGHG: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].NaturalGasGHG,
				categoryDistrictHeatingGHG: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].DistrictHeatingGHG,
				categoryDistrictCoolingGHG: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].DeepLakeGHG,
				categoryWaterGHG: districtPerformance.filter(item => item.Category === 'All Building Categories')[0].WaterGHG,
			});
			return;
		}
		this.setState({
			category: e.target.value,
			categoryEnergy: districtPerformance.filter(item => item.Category === e.target.value)[0].Total,
			categoryEui: districtPerformance.filter(item => item.Category === e.target.value)[0].EUI,
			categoryGFA: districtPerformance.filter(item => item.Category === e.target.value)[0].GFA,
			categoryStructures: districtPerformance.filter(item => item.Category === e.target.value)[0].Structures,
			categoryElectricity: districtPerformance.filter(item => item.Category === e.target.value)[0].Electricity,
			categoryNaturalGas: districtPerformance.filter(item => item.Category === e.target.value)[0].NaturalGas,
			categoryDistrictHeating: districtPerformance.filter(item => item.Category === e.target.value)[0].DistrictHeating,
			categoryDistrictCooling: districtPerformance.filter(item => item.Category === e.target.value)[0].DeepLake,
			categoryWater: districtPerformance.filter(item => item.Category === e.target.value)[0].Water,
			categoryGhg: districtPerformance.filter(item => item.Category === e.target.value)[0].TotalGHG,
			categoryElectricityGHG: districtPerformance.filter(item => item.Category === e.target.value)[0].ElectricityGHG,
			categoryNaturalGasGHG: districtPerformance.filter(item => item.Category === e.target.value)[0].NaturalGasGHG,
			categoryDistrictHeatingGHG: districtPerformance.filter(item => item.Category === e.target.value)[0].DistrictHeatingGHG,
			categoryDistrictCoolingGHG: districtPerformance.filter(item => item.Category === e.target.value)[0].DeepLakeGHG,
			categoryWaterGHG: districtPerformance.filter(item => item.Category === e.target.value)[0].WaterGHG,
    });
		this.props.onBuildingCategoryChange( e.target.value );
  }

	render() {
		
		const totalEnergy = this.state.categoryEnergy.toLocaleString();
		const pEnergy = round(this.state.categoryEnergy / this.state.totalEnergy * 100);
		const structures = this.state.categoryStructures.toLocaleString();
		const pStructures = round(this.state.categoryStructures / this.state.totalStructures * 100);
		const eui = this.state.categoryEui.toLocaleString();
		const totalGhg = this.state.categoryGhg.toLocaleString();
		const pGhg = round(this.state.categoryGhg / this.state.totalGhg * 100);
		const gfa = this.state.categoryGFA.toLocaleString();
		const pGfa = round(this.state.categoryGFA / this.state.totalGFA * 100);
		
		const gwhData=() => {
			const electricityGWh = this.state.categoryElectricity;
			const NaturalGasGwh = this.state.categoryNaturalGas;
			const DistrictHeating = this.state.categoryDistrictHeating;
			const DistrictCooling = this.state.categoryDistrictCooling;
			const Water = this.state.categoryWater;
			return {
				labels: [
					'Electricity',
					'Natural Gas',
					'District Heating',
					'Deep Lake Water Cooling',
					'Water'
				],
				datasets: [{
					data: [electricityGWh, NaturalGasGwh, DistrictHeating, DistrictCooling, Water],
					backgroundColor: ['#fcb040','#ff0000','#bebdff','#5351a3', '#1ca3ec'],
					hoverBackgroundColor:'#777777',
				}]
			};	
		}
	
		const ghgData=() => {
			const electricityGhg = this.state.categoryElectricityGHG;
			const NaturalGasGhg = this.state.categoryNaturalGasGHG;
			const DistrictHeatingGhg = this.state.categoryDistrictHeatingGHG;
			const DistrictCoolingGhg = this.state.categoryDistrictCoolingGHG;
			const WaterGhg = this.state.categoryWaterGHG;
			return {
				labels: [
					'Electricity',
					'Natural Gas',
					'District Heating',
					'Deep Lake Water Cooling',
					'Water'
				],
				datasets: [{
					data: [electricityGhg, NaturalGasGhg, DistrictHeatingGhg, DistrictCoolingGhg, WaterGhg],
					backgroundColor: ['#fcb040','#ff0000','#bebdff','#5351a3', '#1ca3ec'],
					hoverBackgroundColor:'#777777',
				}]
			};	
		}
			
		const chartOptionsDefault={
			events: ['mousemove'], // this is needed, otherwise onHover is not fired
			scales: {
				xAxes: [{		
										gridLines: {
												display:false,
												drawBorder: false,
										},
										scaleLabel: {
											display: true,
										}
								}],
			},
			tooltips: {
				custom: function(tooltip) {
					if (!tooltip) return;
					// disable displaying the color box;
					tooltip.displayColors=false;
				},
			},
			responsive: true,
			maintainAspectRatio: false,
			legend: {
					position: this.state.legendPos,
					labels: {
						boxWidth: 20
					}
			},
			
		};

		const chartOptionsGwh={
			scales: {
				xAxes: [{
									gridLines: {
										display: false,
									},
									ticks: {
										display:false,
									},   	
									scaleLabel: {
										labelString: 'eGWh/year',
									}
							}],
				yAxes: [{
									ticks: {
										display: false
									 },
									gridLines: {
										display: false,
										drawBorder: false,
									},
							}],
			},
			tooltips: {
				callbacks: {
					// use label callback to return the desired label
					label: function(tooltipItem, data) {
						return [data.labels[tooltipItem.index] +':', data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString() +' eGWh/year'];	
					},
					// remove title
					title: function(tooltipItem, data) {
						return;
					}
				}
			}
		};	
		
		const chartOptionsGhg={
			scales: {
				xAxes: [{
									gridLines: {
										display: false,
									},	
									ticks: {
											display:false,
									},   	
									scaleLabel: {
										labelString: 'MtCO₂e/year',
									},
								  stacked: true,
							}],
				yAxes: [{
									ticks: {
										display: false
									 },
									gridLines: {
										display: false,
										drawBorder: false,
									},
								  stacked: true,
							}],
			},
			tooltips: {
				callbacks: {
					// use label callback to return the desired label
					label: function(tooltipItem, data) {
						return [data.labels[tooltipItem.index] +':', data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString() +' MtCO₂e/year'];
					},
					// remove title
					title: function(tooltipItem, data) {
						return;
					}
				}
			}
		};
		
		const gwhOptions = _.merge({}, chartOptionsDefault, chartOptionsGwh);
		const ghgOptions = _.merge({}, chartOptionsDefault, chartOptionsGhg);
		
		return (
			<div className='mx-3 my-3'>
				<h5 className='mb-1'>Select Building Category:</h5>
				<Form className='p-3 '>
					<FormGroup row >
						<Input type='select' name='select' id='selectbuildingCategory'
							onChange={this.handleCategorySelect} >
							{this.state.categorySelect.map(item => <option value={item} key={item}>{item}</option>)}
						</Input>
					</FormGroup>
				</Form>
					<h5 className='my-3'>Energy Use: {totalEnergy} <small>eGWh/year</small> <br /><small>{this.state.category !== 'All Building Categories' && '(' + pEnergy + '% of District)'}</small></h5>
					<div className='pie-chart'>
						<Doughnut data={gwhData} options={gwhOptions} />
					</div>
					<h5 className='my-3'>GHG Emissions: {totalGhg} <small>MtCO₂e/year</small> <br /><small>{this.state.category !== 'All Building Categories' && '(' + pGhg + '% of District)'}</small></h5>
					<div className='pie-chart'>
						<Doughnut data={ghgData} options={ghgOptions} text={12}/>
					</div>
					<Table>
						<tbody>
							{this.state.category === 'All Building Categories' && <tr>
								<td>GHG emissions from transportation to the District <small>(MtCO₂e/year)</small></td>
								<td className = 'text-right'>1.48</td>
							</tr>}
							{this.state.category === 'All Building Categories' && <tr>
								<td>Water usage <small>(m³/year)</small></td>
								<td className = 'text-right'>41,280,000</td>
							</tr>}
							{this.state.category !== 'Industrial' && <tr>
								<td>Energy Use Intensity <small>(ekWh/m²/year)</small></td>
								<td className = 'text-right'>{eui}</td>
							</tr>}
							{this.state.category !== 'Residential' &&<tr>
								<td>Number of structures*</td>
								<td className = 'text-right'>{structures} 
									{this.state.category !== 'All Building Categories' && ' (' + pStructures + '%)'}</td>
							</tr>}
							<tr>
								<td>Gross Floor Area <small>(m²)</small></td>
								<td className = 'text-right'>{gfa}
									{this.state.category !== 'All Building Categories' && ' (' + pGfa + '%)'}</td>
							</tr>
							{this.state.category !== 'Residential' && <tr>
								<td colspan='2'><small>* Buildings that share walls are counted as a single structure</small></td>
							</tr>}
						</tbody>
					</Table>
			</div>
		)
	};
}

export default SidebarDistrictChart;


// WEBPACK FOOTER //
// ./src/SidebarDistrictChart.js


// WEBPACK FOOTER //
// ./src/SidebarDistrictChart.js